import { type ImageInfo } from '../../api/image';

export const defaultMediaItem: ImageInfo = {
    display_sequence: 0,
    file_id: '019a2b59-436c-7451-b889-9fac6114b2f0',
    file_path: 'https://avatars.mdst.yandex.net/get-yastore/1411061/49lc7vkc62wp4ltzzdl8hs47gfh7bs4h/orig',
    sizes: [
        {
            alias: 'optimize',
        },
        {
            alias: 'x160',
            width: 160,
        },
        {
            alias: 'x320',
            width: 320,
        },
        {
            alias: 'x480',
            width: 480,
        },
        {
            alias: 'x640',
            width: 640,
        },
        {
            alias: 'x960',
            width: 960,
        },
        {
            alias: 'x1280',
            width: 1280,
        },
    ],
    file_metadata: {
        thumb_hash: 'PggCBwDod3iId3h/g3iHV5h4CQAAAAAA',
        background_colors: {
            bottom: '#FFFFFFFF',
            left: '#FFFFFFFF',
            right: '#FFFFFFFF',
            top: '#FFFFFFFF',
        },
    },
};
